import { ReactNode, useEffect, useReducer, useRef } from "react";

import { registerMemoryStatsProvider } from "utils/memoryDiagnostics";

import { DispatchContext, initialState, LazyStateContext, reducer, StateContext } from "./reducer";

export function ObjectGroupsProvider({ children }: { children: ReactNode }) {
    const [state, dispatch] = useReducer(reducer, initialState);
    const lazyValue = useRef(state);
    lazyValue.current = state;

    useEffect(() => {
        return registerMemoryStatsProvider("objectGroupsState", () => {
            let loadedGroupCount = 0;
            let compactedGroupCount = 0;
            let idCount = 0;
            let residentBytes = 0;
            for (const group of lazyValue.current) {
                if (!group.ids) {
                    continue;
                }
                loadedGroupCount++;
                if (group.ids.isCompacted) {
                    compactedGroupCount++;
                }
                idCount += group.ids.size;
                residentBytes += group.ids.residentBytes;
            }
            return {
                groupCount: lazyValue.current.length,
                loadedGroupCount,
                compactedGroupCount,
                idCount,
                residentBytes,
            };
        });
    }, []);

    return (
        <StateContext.Provider value={state}>
            <LazyStateContext.Provider value={lazyValue}>
                <DispatchContext.Provider value={dispatch}>{children}</DispatchContext.Provider>
            </LazyStateContext.Provider>
        </StateContext.Provider>
    );
}
